import React from "react";
import styled from "styled-components";
import { SubscribeBtn } from 'components/buttons';

import { TRIAL_DAYS } from "utils/constants";

import Header from "./BookHeader";
import BookTop from "./BookTop";
import Steps from "./Steps";
import About from "./About";


import WhyJP from "../WhyJP";
import SupportedBy from "../SupportedBy";
import MeetJP from "components/Home/MeetJP";
import FeaturedCouses from "components/Home/FeaturedCourses";
import PuddinPops from "../PuddinPops";
import Footer from "components/_core/Footer";
import FinalWords from "components/Home/FinalWords";
import Proof from "../Proof";
import CourseModal from "components/Courses/CourseModal";
import Seo from "components/Seo";
import Separater from "./Separater";
import { localizedText } from "./constants";

const CTA = styled(SubscribeBtn)`
    text-transform: none;

    padding: 13px 30px;
    width: 100%;

    max-width: 350px;
    
    border: 2px solid #fff;
    box-shadow: 0px 6px 0 0 #00000021;

    margin: 30px 0;
    font-size: 20px;

    div {
        font-style: italic;
        font-size: 15px;
    }
`;

const SatisfactionGuarantee = styled.p`
    font-weight: 500;
    color: #666;
    font-size: 14px;
    margin-top: -20px;
`;

const CTAButton = ({ whiteText }) => <>
    <CTA pill large>
        Start Improvising Now!
        {TRIAL_DAYS > 0 ? <div>Try 7 Days Free</div> : <div>Sign Up Now</div>}
    </CTA>
    <SatisfactionGuarantee style={whiteText ? { color: '#fff' }: {}}>100% Satisfaction Guarantee</SatisfactionGuarantee>
</>;

// the same book landing page is served in three languages on three paths
const seoByLang = {
    en: {
        path: '/on-drumming',
        description: 'On Drumming by JP Bouvet — a book on the psychology and philosophy of improvisation, '
            + 'and how creative freedom on the drums can actually be learned.'
    },
    fr: {
        path: '/delabatterie',
        description: 'De La Batterie de JP Bouvet — un livre sur la psychologie et la philosophie de l’improvisation, '
            + 'et sur la façon dont la liberté créative à la batterie s’apprend vraiment.'
    },
    es: {
        path: '/sobrelabateria',
        description: 'Sobre la batería de JP Bouvet — un libro sobre la psicología y la filosofía de la improvisación, '
            + 'y sobre cómo la libertad creativa en la batería sí se puede aprender.'
    }
};

const hreflangAlternates = Object.keys(seoByLang)
    .map(key => ({ lang: key, path: seoByLang[key].path }))
    .concat([{ lang: 'x-default', path: seoByLang.en.path }]);

const BookLandingPage = ({ lang = 'en' }) => {
    const text = localizedText[lang] || localizedText['en'];
    const seo = seoByLang[lang] || seoByLang.en;

    return (
        <div style={{ overflow: 'hidden'}}>
            <Seo
                title={text.title}
                description={seo.description}
                path={seo.path}
                lang={lang}
                type="book"
                alternates={hreflangAlternates}
                jsonLd={{
                    '@context': 'https://schema.org',
                    '@type': 'Book',
                    name: text.title,
                    description: seo.description,
                    inLanguage: lang,
                    bookFormat: 'https://schema.org/Paperback',
                    numberOfPages: 162,
                    author: { '@type': 'Person', name: 'JP Bouvet' },
                    ...(lang === 'en' ? { isbn: '9798218529062' } : {})
                }} />
            <Header text={text} />

            <BookTop lang={lang} text={text} showAdditionalBuyButtons={lang === 'en'} />
            <Steps text={text} />
            <About text={text} />
            <Separater text={text} />
            
            <WhyJP Button={CTAButton} />
            <Proof Button={CTAButton} />
            <SupportedBy />
            <PuddinPops Button={CTAButton} />
            <MeetJP Button={CTAButton} />
            <FeaturedCouses />
            <FinalWords />
            <Footer />
            <CourseModal />
        </div>
    );
};

export default BookLandingPage;
